const $dataSource = $('#dataSource');

export const schools = $dataSource.data('schools') || null;
export const teachers = $dataSource.data('teachers') || null;
export const staffs = $dataSource.data('staffs') || null;
export const departments = $dataSource.data('departments') || null;
export const grades = $dataSource.data('grades') || null;
export const staffTools = $dataSource.data('staffTools') || null;
export const teacherTools = $dataSource.data('teacherTools') || null;
export const toolTypes = $dataSource.data('toolTypes') || null;
export const toolLabels = $dataSource.data('toolLabels') || null;

export const db = {
  schools,
  teachers,
  teacherTools,
  departments,
  grades,
  staffs,
  staffTools,
  toolTypes,
  toolLabels
};
